import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { ConsultationStatusService } from '../../consultation/consultation-status/consultation-status.service';
import { Router } from '@angular/router';
import { DialogService } from '../../../shared/services/dialog.service';
import { AppConstants } from '../../../shared/constants/constants';
import { SharedService } from '../../../shared/services/share.services';
@Component({
    selector: 'ch-invoice',
    templateUrl: 'invoice.component.html',
    providers: [ConsultationStatusService]
})

export class InvoiceComponent implements OnInit {
    @Input() history: string;
    @Input() patientId: string;
    @Input() consultationId: string;
    @Input() invoices: any[];
    @Input() height: number;
    @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();
    public appConstants = AppConstants;
    public klass = 'consultationhistory';
    constructor(public dialog: DialogService, public consultationStatusService: ConsultationStatusService,
        public router: Router, public shareServices: SharedService) { }

    ngOnInit() {
        this.height = this.height ? (this.height > 600 ? this.height - 172 : this.height - 185) : null;
    }
    openInvoice(invoiceId, consultationId) {
      if( consultationId != null){
        this.router.navigate(['consultation/cash-sale/', consultationId, this.patientId, 'edit'], {
          queryParams:
              {
                  invoiceId: invoiceId
              }
      });
      }
      else{
        this.router.navigate(['consultation/cash-sale/invoice/', this.patientId, 'edit'], {
          queryParams:
              {
                  invoiceId: invoiceId
              }
      });
      }


        this.change.emit(true);
    }
    showInvoiceReport(invoice) {
        const params = {
            [AppConstants.reportParameter.InvoiceNo]: invoice.invoiceNumber,
            [AppConstants.reportParameter.currency]: invoice.currencyCode,
            [AppConstants.reportParameter.pdfprintType]: 'pdf'
        };
        this.shareServices.showReport('Invoice', params);
    }
    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/invoice/invoice.component.ts